module.exports = __webpack_public_path__ + "img/9.eb98de05.jpg";